import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const errorDetailTaskCheckConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default errorDetailTaskCheckConfig;
